import { Dialog, DialogContent } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import warningDelete from '../../assets/icons/warning-delete.png';
import DynamicButton from './DynamicButton';
import Loader from './Loader';
import DeleteMultipleSessionsWarning from './DeleteConfirmWarning';
import { CustomApiError } from '../../utils/utilsts';
import { SessionDeleteError } from '../../utils/types';

interface DeleteConfirmModalProps {
  open: boolean;
  onClose: () => void;
  confirmDelete: () => void;
  isLoading: boolean;
  error: Error | null;
  isSuccess: boolean;
  isError: boolean;
}

export const DeleteConfirmModal = ({
  onClose,
  open,
  confirmDelete,
  isLoading,
  error,
  isSuccess,
  isError,
}: DeleteConfirmModalProps) => {
  const formatMessageCannotDelete = (errorToFormat: Error | null) => {
    if (errorToFormat instanceof CustomApiError) {
      if (errorToFormat.response.code === SessionDeleteError.code.USERS_ENROLL)
        return SessionDeleteError.message.USERS_ENROLL;
      if (errorToFormat.response.code === SessionDeleteError.code.SESSION_NOT_FOUND)
        return SessionDeleteError.message.SESSION_NOT_FOUND;
      return SessionDeleteError.message.UNKNOWN_ERROR;
    }
    return SessionDeleteError.message.UNKNOWN_ERROR;
  };

  const handleClose = () => {
    if (isLoading) return;
    onClose()
  }

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      onClose={handleClose}
      open={open}
      className="delete-multiple-sessions-modal"
    >
      <DialogContent className="delete-multiple-sessions-modal__content">
        <div onClick={handleClose} className="delete-multiple-sessions-modal__icon-container">
          <CloseOutlinedIcon className="delete-multiple-sessions-modal__icon-container__icon" />
        </div>

        <img className="delete-multiple-sessions-modal__warning-icon" srcSet={warningDelete} alt="" />
        {isError ? (
          <div className="modal-error align-flex-center">
            <p className="modal-error__title">Error</p>
            <p className="modal-error__message">{formatMessageCannotDelete(error)}</p>
            <div className="modal-error__button">
              <DynamicButton type="tertiary" size="medium" onClick={onClose}>
                OK
              </DynamicButton>
            </div>
          </div>
        ) : (
          <>
            {isLoading || isSuccess ? (
              <Loader />
            ) : (
              <DeleteMultipleSessionsWarning
                onClose={onClose}
                onConfirm={confirmDelete}
              />
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmModal;
